import React, { useState, useEffect, useCallback } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClock, faPencil, faTrash } from "@fortawesome/free-solid-svg-icons";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Table,
  CardHeader,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Spinner,
  Badge,
  Input,
  InputGroupText,
  InputGroup,
} from "reactstrap";
import { Link } from "react-router-dom";
import MetaTags from "react-meta-tags";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ApiClient from "../BaseUrl/ApiClient";
import axios from "axios";

const debounce = (func, delay) => {
  let timeoutId;
  return (...args) => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => func(...args), delay);
  };
};

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

function CategoriesList() {
  const token = localStorage.getItem("accessToken");
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");

  const [deleteModal, setDeleteModal] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);

const fetchCategories = async (query = "") => {
  setLoading(true);
  setError(null);
  try {
    const client = ApiClient();
    const response = await client.get("admin/categories");
    setCategories(response.data.responseData.categories);
  } catch (error) {
    toast.error("Failed to fetch categories");
    setError("Failed to fetch categories. Please try again.");
  } finally {
    setLoading(false);
  }
};


  useEffect(() => {
    fetchCategories();
  }, []);


  const confirmDelete = (category) => {
    setSelectedCategory(category);
    setDeleteModal(true);
  };

  const deleteCategory = async () => {
    try {
      const client = ApiClient();
      await client.delete(`admin/categories/${selectedCategory._id}`);
      setCategories(prevCategories =>
        prevCategories.filter(category => category._id !== selectedCategory._id)
      );
      toast.success("Category deleted successfully");
      setDeleteModal(false);
      setSelectedCategory(null);
    } catch (error) {
      toast.error("Failed to delete category");
      setDeleteModal(false);
      setSelectedCategory(null);
    }
  };



  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid className="mt-5">
          <MetaTags>
            <title>Categories List</title>
          </MetaTags>
          <ToastContainer />

          <Modal isOpen={deleteModal} centered>
            <ModalHeader>Confirm Delete</ModalHeader>
            <ModalBody>
              {selectedCategory && (
                <>
                  <p>
                    Do you really want to delete the category{" "}
                    <strong>"{selectedCategory.name}"</strong>?
                  </p>
                  <p className="text-danger">This action cannot be undone.</p>
                </>
              )}
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={() => setDeleteModal(false)}>
                Cancel
              </Button>
              <Button color="danger" onClick={deleteCategory}>
                Yes, Delete
              </Button>{" "}
              
            </ModalFooter>
          </Modal>

          <Row>
            <Col xl={12}>
              <Card>
                <CardHeader>
                  <Row>
                    <div>
                      <Row className="g-4 mt-0">
                        <Col md={4}>
                          <div className="mt-0">
                            <h4>Categories List</h4>
                          </div>
                        </Col>
                        <Col md={8}>
                          <div className="d-flex justify-content-sm-end align-items-center position-relative mb-3">
                            <Link
                              to="/add-categories"
                              className="btn btn-success me-2"
                            >
                              + Add Category
                            </Link>

                            {/* <div className="search-box ms-2 position-relative">
                              <Input
                                type="text"
                                className="form-control search"
                                placeholder="Search categories..."
                                value={searchQuery}
                                onChange={handleSearchInputChange}
                                onKeyPress={(e) =>
                                  e.key === "Enter" && fetchCategories(searchQuery)
                                }
                              />
                              <i className="ri-search-line search-icon"></i>
                              {searchQuery && (
                                <i
                                  className="ri-close-line clear-icon"
                                  style={{
                                    position: "absolute",
                                    right: "10px",
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    cursor: "pointer",
                                    fontSize: "18px",
                                    color: "#666",
                                  }}
                                  onClick={clearSearch}
                                />
                              )}
                            </div> */}
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </Row>
                </CardHeader>
                <CardBody>
                  {error && <p className="text-danger">{error}</p>}
                  {loading ? (
                    <div
                      className="d-flex justify-content-center align-items-center"
                      style={{ minHeight: "300px" }}
                    >
                      <div className="text-center">
                        <Spinner
                          color="primary"
                          style={{ width: "3rem", height: "3rem" }}
                        />
                        <p className="mt-2">Loading categories...</p>
                      </div>
                    </div>
                  ) : (
                    <div className="live-preview">
                      <div className="table-responsive table-card">
                        <Table className="align-middle table-nowrap mb-0">
                          <thead className="table-light">
                            <tr>
                              <th scope="col">Category Photo</th>
                              <th scope="col">Category Name</th>
                    
                              <th scope="col">Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {categories.length > 0 ? (
                              categories.map((category) => (
                                <tr key={category._id}>
                                  <td>
                                    {category.categoryLogo?.url ? (
                                      <img
                                        src={category.categoryLogo.url}
                                        alt={category.name}
                                        style={{
                                          width: "60px",
                                          height: "60px",
                                          objectFit: "contain",
                                          padding: "5px",
                                          borderRadius: "4px",
                                        }}
                                      />
                                    ) : (
                                      <p>No Logo</p>
                                    )}
                                  </td>
                                  <td>{category.name}</td>
                               
                                  <td>
                                    <div className="d-flex gap-2">
                                
                                      <Link to={`/update-categories/${category.id}`}>
                                        <button
                                          type="button"
                                          className="btn btn-sm btn-success"
                                        >
                                          <FontAwesomeIcon icon={faPencil} />
                                        </button>
                                      </Link>
                                      <button
                                        type="button"
                                        className="btn btn-sm btn-danger"
                                        onClick={() => confirmDelete(category)}
                                      >
                                        <FontAwesomeIcon icon={faTrash} />
                                      </button>
                                    </div>
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan="4" className="text-center">
                                  <div className="text-center">
                                    <lord-icon
                                      src="https://cdn.lordicon.com/msoeawqm.json"
                                      trigger="loop"
                                      colors="primary:#121331,secondary:#08a88a"
                                      style={{ width: "75px", height: "75px" }}
                                    ></lord-icon>
                                    <h5 className="mt-2">
                                      Sorry! No Result Found
                                    </h5>
                                    <p className="text-muted mb-0">
                                      We've searched for categories but did not find
                                      any matching results.
                                    </p>
                                  </div>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </Table>
                      </div>
                    </div>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
}

export default CategoriesList;